import React from 'react';
import ApiService from '@Utils/apiService'
import * as Path from './apiRoutes'
import moment from 'moment'
import * as Actions from './actions'
import { cloneDeep } from 'lodash';

// ONBOARDING LIST OPERATIONS
export const getListOnboarding = () => async (dispatch, getState) => {
    dispatch(Actions.isLoading(true))
    const { onboardingList: { resultTable: { appliedFilter } } } = getState()
    const { auth } = getState()

    let sortModel = null
    let updateSortModel = cloneDeep(appliedFilter)
    if (Object.keys(updateSortModel.Sort).length > 0) {
        let currentSortModel = updateSortModel.Sort
        sortModel = {
            Column: currentSortModel.field,
            Order: currentSortModel.sort
        }
    }
    updateSortModel.Sort = sortModel
    updateSortModel.CompanyId = auth.credentials.companyId
    updateSortModel.UserID = auth.credentials.userId

    ApiService.get(Path.LIST, updateSortModel)
        .then((response) => {
            if (response) {
                const { data } = response
                dispatch(Actions.updateOnboardingList({
                    data: data.items,
                    totalCount: data.count,
                }))
            }
            // return response.data
        })
        .catch((error) => {
            console.error(error)
        }).finally(() => {
            dispatch(Actions.isLoading(false))
        })
}

// LIST ACTIONS/ACTION OPERATIONS
export const applySearchFilters = (searchModel) => (dispatch) => {
    // Page will always be zero upon searching
    dispatch(Actions.changeFilterPage(0))

    // dispatch the search filters
    dispatch(Actions.applyFilters(searchModel))

    // get data from server and update results
    dispatch(getListOnboarding())
}

export const resetSearchResults = () => (dispatch) => {
    // reset filter
    dispatch(Actions.resetResults())
    // Update the list
    dispatch(getListOnboarding())
}

export const resetFilters = () => (dispatch, getState) => {
    dispatch(Actions.resetFilters())
    return new Promise((resolve, reject) => {
        const { onboardingList: { searchFilter } } = getState()
        resolve(searchFilter)
    })
}

export const changePage = (newPage) => (dispatch) => {
    // dispatch change filter page
    dispatch(Actions.changeFilterPage(newPage))
    // Update the list
    dispatch(getListOnboarding())
}

export const changeRowsPerPage = (pageModel) => (dispatch) => {
    // dispatch change filter page size
    dispatch(Actions.changeFilterRowsPerPage(pageModel))
    // Update list
    dispatch(getListOnboarding())
}

export const changeSort = (sortModel) => (dispatch) => {
    // dispatch change filter page size
    dispatch(Actions.changeFilterSort(sortModel))
    // Update list
    dispatch(getListOnboarding())
}

// ONBOARDING ADD ACTIONS/ACTION OPERATIONS
export const createOnboardingTraining = (onboardingTraining) => (dispatch, getState) => {
    const { onboardingAdd: { alert } } = getState();
    let nAlert = { ...alert };
    dispatch(Actions.showLoading(true));

    return ApiService.post(Path.ROOT, onboardingTraining)
        .then((response) => {
            if (response) {
                let title = 'Create Success';
                const { message } = response.data;
                let goBackToList = true;

                if (response.data.returnCode <= 0) {
                    title = 'Create Failed';
                    goBackToList = false;
                }

                nAlert = {
                    ...nAlert,
                    title: title,
                    show: true,
                    content: message,
                    goBackToListFlag: goBackToList,
                };
            }
        })
        .catch((error) => {

            console.error('API Error:', error.response);
            if (error.response) {
                console.error('Error details:', error.response.data);
            }
        })
        .finally(() => {
            dispatch(Actions.showLoading(false));
            dispatch(Actions.updateAddAlertData(nAlert));
        });
};

export const getTrainings = (selectedCategory) => async (dispatch, getState) => {
    dispatch(Actions.insertLoading(true));
    const { auth } = getState();
    let data;
    let companyID = auth.credentials.companyId;
    try {
        const response = await ApiService.get(Path.TRAINING, { selectedCategory, companyID });
        if (response) {
            data = response.data;
        }
    } catch (error) {
        console.error(error);
    } finally {
        dispatch(Actions.insertLoading(false));
    }

    return data;
};

export const getCategory = (id) => async (dispatch, getState) => {
    dispatch(Actions.insertLoading(true));
    const { auth } = getState();
    let data;
    let companyID = auth.credentials.companyId;

    try {
        const response = await ApiService.get(Path.CATEGORY, { id });
        if (response) {
            data = response.data;
        }
    } catch (error) {
        console.error(error);
    } finally {
        dispatch(Actions.insertLoading(false));
    }

    return data;
};

export const getHolidayDates = (company) => (dispatch) => {
    dispatch(Actions.showLoading(true));
    return ApiService.get(Path.GET_HOLIDAY_DATES, { company })
        .then((response) => {
            let listData = response ? response.data.map(date => moment(date).format("YYYY-MM-DD")) : [];
            dispatch(Actions.setHolidayDates({ holidayDates: listData }));
            return listData;
        })
        .finally(() => {
            dispatch(Actions.showLoading(false));
            
        });
}

export const fetchOnboardingAddEmailPreview = (model) => (dispatch) => {
    dispatch(Actions.showLoading(true));

    return ApiService.post(Path.GET_ONBOARDING_ADD_EMAIL_PREVIEW, model)
        .then((response) => {
            if (response && response.data) {
                dispatch(Actions.setAddEmailTemplate(response.data));
            }
        })
        .catch((error) => {
            console.error('Error fetching email preview', error);
            dispatch(Actions.updateAddAlertData({
                show: true,
                title: 'Error',
                content: 'Failed to load email preview',
                goBackToListFlag: false,
            }));
        })
        .finally(() => {
            dispatch(Actions.showLoading(false));
        });
};

// ONBOARDING DETAIL OPERATIONS
export const getOnboardingDetail = (onboardingTrainingID, mode) => async (dispatch) => {
    dispatch(Actions.hasDetailLoaded(false));
    try {
        const response = await ApiService.get(Path.DETAILS, { id: onboardingTrainingID });

        if (response) {
            dispatch(Actions.setDetailData(response.data, mode));
        }
        
        return response;

    } catch (error) {
        console.error("Error fetching details:", error);
    } finally {
        dispatch(Actions.hasDetailLoaded(true));
    }
};

// ONBOARDING DELETE RECORD OPERATIONS
export const deleteRecord = (data) => (dispatch) => {
    dispatch(Actions.isLoading(true))

    let returnValue = {
        data: {},
        alertData: {
            show: true,
            title: 'Update Success',
            content: 'Onboarding Training successfully deleted.',
            confirmLabel: 'Ok',
        }
    }
    const { onboardingTrainingID } = data;
    return ApiService.delete(`${Path.ROOT}/${onboardingTrainingID}`)
        .then((response) => {
            if (response) {
                let title = 'Delete Success'
                const { message } = response.data
                if (response.data.returnCode <= 0) {
                    title = 'Delete Failed'
                }
                returnValue.data = response.data
                returnValue.alertData = {
                    show: true,
                    title: title,
                    content: message,
                    confirmLabel: 'Ok',
                }
            }
            return returnValue;
        })
        .catch((error) => {
            console.error(error)
        }).finally(() => {
            dispatch(Actions.isLoading(false))
        })
}

// ONBOARDING UPDATE/EDIT OPERATIONS
export const updateOnboardingTraining = (values, id) => (dispatch, getState) => {
    dispatch(Actions.hasDetailLoaded(false))
    let updateModel = dispatch(convertToUpdateModel(values));

    let returnValue = {
        data: {},
        alertData: {
            show: true,
            title: 'Updated Success',
            content: 'Successfuly updated record.',
            confirmLabel: 'Ok',
        }
    }

    return ApiService.put(Path.ROOT + '/' + id, updateModel)
        .then((response) => {
            if (response) {
                let title = 'Update Success';
                const { message } = response.data;
                let goBackToList = true;
                if (response.data.returnCode <= 0) {
                    title = 'Update Failed';
                    goBackToList = false;
                }

                returnValue.data = response.data;
                returnValue.alertData = {
                    show: true,
                    title: title,
                    content: message != null ? message : 'Successfuly updated Onboarding Details.',
                    confirmLabel: 'Ok',
                    goBackToListFlag: goBackToList,
                }
            }
            return returnValue;
        })
        .catch((error) => {
            console.error('API Error:', error);
            return returnValue;
        }).finally(() => {
            dispatch(Actions.hasDetailLoaded(true))
        })
}

export const createOnboardingTrainingWithEmail = (onboardingTraining, editedTemplate) => (dispatch, getState) => {
    const { onboardingAdd: { alert } } = getState();
    let nAlert = { ...alert };
    dispatch(Actions.showLoading(true));

    return ApiService.post(Path.CREATE_ONBOARDING_ADD_WITH_EMAIL, {
        model: onboardingTraining,
        editedTemplate: editedTemplate
    })
        .then((response) => {
            if (response) {
                let title = 'Create Success';
                const { message } = response.data;
                let goBackToList = true;

                if (response.data.returnCode <= 0) {
                    title = 'Create Failed';
                    goBackToList = false;
                }

                nAlert = {
                    ...nAlert,
                    title: title,
                    show: true,
                    content: message,
                    goBackToListFlag: goBackToList,
                };
            }
        })
        .catch((error) => {

            console.error('API Error:', error.response);
            if (error.response) {
                console.error('Error details:', error.response.data);
            }
        })
        .finally(() => {
            dispatch(Actions.showLoading(false));
            dispatch(Actions.updateAddAlertData(nAlert));
        });
};

export const updateOnboardingTrainingWithEmail = (detailData, ID, editedTemplate) => (dispatch, getState) => {
    dispatch(Actions.hasDetailLoaded(false))
    let updateModel = dispatch(convertToUpdateModel(detailData));

    let returnValue = {
        data: {},
        alertData: {
            show: true,
            title: 'Updated Success',
            content: 'Successfuly updated record.',
            confirmLabel: 'Ok',
        }
    }

    return ApiService.post(Path.UPDATE_ONBOARDING_DETAIL_WITH_EMAIL, {
        id: ID,
        model: updateModel,
        editedTemplate: editedTemplate
    })
        .then((response) => {
            if (response) {
                let title = 'Update Success';
                const { message } = response.data;
                let goBackToList = true;
                if (response.data.returnCode <= 0) {
                    title = 'Update Failed';
                    goBackToList = false;
                }

                returnValue.data = response.data;
                returnValue.alertData = {
                    show: true,
                    title: title,
                    content: message != null ? message : 'Successfuly updated Onboarding Details.',
                    confirmLabel: 'Ok',
                    goBackToListFlag: goBackToList,
                }
            }
            return returnValue;
        })
        .catch((error) => {
            console.error('API Error:', error);
            return returnValue;
        }).finally(() => {
            dispatch(Actions.hasDetailLoaded(true))
        })
}

//ONBOARIDING EXPORT LIST OPERATIONS
export const exportRecord = (filename, selectedFields) => (dispatch, getState) => {
    dispatch(Actions.isLoading(true))
    const { onboardingList: { searchFilter } } = getState()
    const { auth } = getState()

    let sortModel = null
    let updateSortModel = cloneDeep(searchFilter)
    if (Object.keys(updateSortModel.Sort).length > 0) {
        let currentSortModel = updateSortModel.Sort
        sortModel = {
            Column: currentSortModel.field,
            Order: currentSortModel.sort
        }
    }
    updateSortModel.Sort = sortModel
    updateSortModel.CompanyId = auth.credentials.companyId
    updateSortModel.UserID = auth.credentials.userId
    updateSortModel.Headers = selectedFields

    return ApiService.export(Path.EXPORT_ONBOARDING_LIST, filename, updateSortModel)
        .catch((error) => {
            console.error(error)
        })
        .finally(() => {
            dispatch(Actions.isLoading(false))
        })
}

export const exportOnboardingDetail = (filename, id) => (dispatch, getState) => {
    dispatch(Actions.isLoading(true))

    const { auth } = getState()

    const payload = {
        ID: id,
        CompanyId: auth.credentials.companyId
    }

    return ApiService.export(
        Path.EXPORT_ONBOARDING_DETAILS,
        filename,
        payload,
        id
    )
        .catch(error => {
            console.error(error)
        })
        .finally(() => {
            dispatch(Actions.isLoading(false))
        })
}

// ONBOARDING ATTENDANCE OPERATIONS
export const updateParticipantAttendance = (id, model) => async (dispatch) => {
    dispatch(Actions.insertLoading(true));
    let returnValue = {
        data: {},
        alertData: {
            show: true,
            title: 'Update Success',
            content: 'Successfuly updated record.',
            confirmLabel: 'Ok',
        }
    }
    return ApiService.put(Path.ROOT + '/attendance/' + id, model)
        .then((response) => {
            if (response) {
                let title = 'Update Success';
                const { message } = response.data;
                let goBackToList = true;
                if (response.data.returnCode <= 0) {
                    title = 'Update Failed';
                    goBackToList = false;
                }

                returnValue.data = response.data;
                returnValue.alertData = {
                    show: true,
                    title: title,
                    content: message != null ? message : 'Successfuly updated Onboarding Details.',
                    confirmLabel: 'Ok',
                    goBackToListFlag: goBackToList,
                }
            }
            return returnValue;
        })
        .catch((error) => {
            console.error('API Error:', error.response ? error.response.data : error);
            return returnValue;
        }).finally(() => {
            dispatch(Actions.insertLoading(false));
        })
};

export const fetchOnboardingDetailEmailPreview = (model) => (dispatch) => {
    dispatch(Actions.showLoading(true));
    let convertModel = dispatch(convertToUpdateModel(model));

    return ApiService.post(Path.GET_ONBOARDING_DETAIL_EMAIL_PREVIEW, convertModel)
        .then((response) => {
            if (response && response.data) {
                dispatch(Actions.setDetailEmailTemplate(response.data));
            }
        })
        .catch((error) => {
            console.error('Error fetching email preview', error);
            dispatch(Actions.updateAddAlertData({
                show: true,
                title: 'Error',
                content: 'Failed to load email preview',
                goBackToListFlag: false,
            }));
        })
        .finally(() => {
            dispatch(Actions.showLoading(false));
        });
};

// Participant List:
export const getParticipantSelection = () => async (dispatch, getState) => {
    dispatch(Actions.insertLoading(true));

    const { auth } = getState();
    let data;
    let companyID = auth.credentials.companyId;

    try {
        const response = await ApiService.get(Path.TRAINEE, { companyID });
        if (response) {
            data = response.data;
        }
    } catch (error) {
        console.error(error);
    } finally {
        dispatch(Actions.insertLoading(false));
    }

    return data;
};

export const getParticipantList = (onboardingTrainingID) => async (dispatch, getState) => {
    dispatch(Actions.insertLoading(true));

    let data;
    try {
        const response = await ApiService.get(Path.PARTICIPANT, { id: onboardingTrainingID });
        if (response) {
            data = response.data;
        }
    } catch (error) {
        console.error(error);
    } finally {
        dispatch(Actions.insertLoading(false));
    }

    return data;
};

// Export Participant List:
export const exportParticipantList = (filename, onboardingTrainingID) => (dispatch) => {
    dispatch(Actions.isLoading(true));

    return ApiService.export(Path.EXPORT_ATTENDANCE, filename, { id: onboardingTrainingID })
        .then((response) => {
            return response;
        })
        .catch((error) => {
            console.error(error);
        }).finally(() => {
            dispatch(Actions.isLoading(false));
        });
};

export const resendFacilitatorLink = (trainingId, facilitatorId) => (dispatch, getState) => {
    dispatch(Actions.hasDetailLoaded(false));

    let returnValue = {
        data: {},
        alertData: {
            show: true,
            title: 'Resend Success',
            content: 'Invitation resent successfully.',
            confirmLabel: 'Ok',
            goBackToListFlag: false,
        }
    };

    dispatch(Actions.showLoading(true));

    return ApiService.post(Path.RESEND, { TrainingId: trainingId, FacilitatorId: facilitatorId })
        .then((response) => {
            if (response) {
                let title = 'Resend Success'
                const { message, returnCode } = response.data;

                let goBackToList = false;
                if (returnCode <= 0) {
                    title = 'Resend Failed'
                }

                returnValue.data = response.data;
                returnValue.alertData = {
                    show: true,
                    title: title,
                    content: message != null ? message : 'Invitation resent successfully.',
                    confirmLabel: 'Ok',
                    goBackToListFlag: goBackToList,
                }
            }
            return returnValue;
        })
        .catch((error) => {
            if (error.response) {
                returnValue.alertData = {
                    show: true,
                    title: 'Resend Failed',
                    content: error.response.data,
                    confirmLabel: 'Ok',
                    goBackToListFlag: false,
                }
            }
            return returnValue
        })
        .finally(() => {
            dispatch(Actions.hasDetailLoaded(true))
        })
}

export const convertToUpdateModel = (values) => (dispatch, getState) => {
    const { auth } = getState();
    let userId = auth.credentials.userId;
    let nCreatedDate = moment.utc().format();
    const updateModel = {
        OnboardingTrainingID: values.onboardingTrainingID,
        TrainingCategory: values.trainingCategory,
        facilitator: values.facilitator,
        startTrainingDate: moment(values.startTrainingDate).format('YYYY-MM-DDTHH:mm:ss'),
        endTrainingDate: moment(values.endTrainingDate).format('YYYY-MM-DDTHH:mm:ss'),
        OnboardingStatus: values.onboardingStatus,
        onboardingType: values.onboardingType,
        OnboardingTypeName: values.onboardingTypeName,
        CreatedDate: nCreatedDate,
        CreatedBy: userId,
        TrainingMasterModuleID: values.trainingMasterModuleID,

    };
    return updateModel;
};